<template>
  <div id="HistoriesView">
    <HistoriesStaff/>
  </div>
</template>

<script>
import HistoriesStaff from '../../components/staff/historiesStaff.vue';
export default {
  components: { HistoriesStaff },
  name: "HistoriesView",
 
};
</script>

<style scoped>

</style>
